import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants/common';

const initialState = {
  users: [],
  status: [],
  creators: [],
  assigned: [],
  userGroups: [],
  paginationUserGroups: {},
  user: null,
  errors: {},
  message: null,
  loading: false,
  pagination: {},
  userPrivileges: {},
  fetchingUser: false,
  assignedLoading: false,
  creatorsLoading: false,
  fetchingPrivileges: false,
  fetchingUserGroups: false,
  fetchingAction: false,
  fetchingUserRole: false,
  fetchingUserStatus: false,
  fetchingUpdateUser: false,
  showConfirmAction: false,
  fetchingDeleteUserGroup: false,
  fetchedUpdateUserSuccess: false,
  fetchingDeleteUser: false,
  fetchedDeleteUserError: false,
  fetchedDeleteUserSuccess: false,
  fetchingChangeUserRole: false,
  fetchingChangeUserStatus: false,
  fetchedChangeUserRoleSuccess: false,
  fetchedDeleteUserGroupSuccess: false,
  fetchedChangeUserStatusSuccess: false,
  fetchedAddUserVehicleGroupSuccess: false,
  fetchedDeleteUserVehicleGroupSuccess: false,
  fetchingAddUserGroup: false,
  fetchingAddVehicleGroup: false,
  fetchedAddUserGroupSuccess: false,
  fetchingDeleteVehicleGroup: false,
  fetchedAccountBrokers: false,
  fetchingAccountBrokers: false,
  fetchingDeletionUser: FETCH_STATE.UNSENT,
};

const usersReducer = createReducer(initialState)({
  // GET USERS
  [types.FETCH_USERS_REQUEST]: (state, { payload }) => {
    const loading = payload === 'users' ? 'loading' : `${payload}Loading`;
    return {
      ...state,
      [loading]: true,
    };
  },
  [types.FETCH_USERS_SUCCESS]: (state, { payload }) => {
    const loading = payload.type === 'users' ? 'loading' : `${payload.type}Loading`;
    return {
      ...state,
      [loading]: false,
      [payload.type]: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_USERS_FAILED]: (state, { payload }) => {
    const loading = payload === 'users' ? 'loading' : `${payload}Loading`;
    return {
      ...state,
      [loading]: false,
    };
  },
  // GET USER STATUS
  [types.FETCH_USERS_STATUS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUserStatus: true,
    };
  },
  [types.FETCH_USERS_STATUS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      status: payload,
      fetchingUserStatus: false,
    };
  },
  [types.FETCH_USERS_STATUS_FAILED]: (state) => {
    return {
      ...state,
      fetchingUserStatus: false,
    };
  },
  // GET USER BY ID
  [types.FETCH_USER_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      user: null,
      fetchingUser: true,
    };
  },
  [types.FETCH_USER_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      user: payload,
      fetchingUser: false,
    };
  },
  [types.FETCH_USER_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingUser: false,
    };
  },
  [types.RESET_USER]: (state) => {
    return {
      ...state,
      user: null,
    };
  },
  // USER INFO ACTIONS
  [types.FETCH_USER_INFO_ACTION_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAction: true,
    };
  },
  [types.FETCH_USER_INFO_ACTION_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingAction: false,
    };
  },
  [types.FETCH_USER_INFO_ACTION_FAILED]: (state) => {
    return {
      ...state,
      fetchingAction: false,
    };
  },
  // UPDATE USER STATUS
  [types.FETCH_UPDATE_USER_STATUS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingChangeUserStatus: true,
      fetchedChangeUserStatusSuccess: false,
    };
  },
  [types.FETCH_UPDATE_USER_STATUS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      user: payload,
      fetchingChangeUserStatus: false,
      fetchedChangeUserStatusSuccess: true,
    };
  },
  [types.FETCH_UPDATE_USER_STATUS_FAILED]: (state, { payload }) => {
    return {
      ...state,
      fetchingChangeUserStatus: false,
      fetchedChangeUserStatusSuccess: false,
    };
  },
  [types.FETCH_RESET_UPDATE_USER_STATUS]: (state) => {
    return {
      ...state,
      fetchingChangeUserStatus: false,
      fetchedChangeUserStatusSuccess: false,
    };
  },
  // UPDATE USER ROLE
  [types.FETCH_UPDATE_USER_ROLE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingChangeUserRole: true,
      fetchedChangeUserRoleSuccess: false,
    };
  },
  [types.FETCH_UPDATE_USER_ROLE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      user: payload,
      fetchingChangeUserRole: false,
      fetchedChangeUserRoleSuccess: true,
    };
  },
  [types.FETCH_UPDATE_USER_ROLE_FAILED]: (state) => {
    return {
      ...state,
      fetchingChangeUserRole: false,
      fetchedChangeUserRoleSuccess: false,
    };
  },
  [types.FETCH_RESET_UPDATE_USER_ROLE]: (state) => {
    return {
      ...state,
      fetchingChangeUserRole: false,
      fetchedChangeUserRoleSuccess: false,
    };
  },
  // GET USER GROUPS
  [types.FETCH_USER_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUserGroups: true,
    };
  },
  [types.FETCH_USER_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingUserGroups: false,
      userGroups: payload.data,
      paginationUserGroups: payload.pagination,
    };
  },
  [types.FETCH_USER_GROUPS_FAILED]: (state) => {
    return {
      ...state,
      fetchingUserGroups: false,
    };
  },
  // ADD USER GROUPS
  [types.FETCH_ADD_USER_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAddUserGroup: true,
      fetchedAddUserGroupSuccess: false,
    };
  },
  [types.FETCH_ADD_USER_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingAddUserGroup: false,
      fetchedAddUserGroupSuccess: true,
    };
  },
  [types.FETCH_ADD_USER_GROUPS_FAILED]: (state) => {
    return {
      ...state,
      fetchingAddUserGroup: false,
      fetchedAddUserGroupSuccess: false,
    };
  },
  // ADD VEHICLE GROUPS
  [types.FETCH_ADD_USER_VEHICLE_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAddVehicleGroup: true,
      fetchedAddUserVehicleGroupSuccess: false,
    };
  },
  [types.FETCH_ADD_USER_VEHICLE_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingAddVehicleGroup: false,
      fetchedAddUserVehicleGroupSuccess: true,
    };
  },
  [types.FETCH_ADD_USER_VEHICLE_GROUPS_FAILED]: (state) => {
    return {
      ...state,
      fetchingAddVehicleGroup: false,
      fetchedAddUserVehicleGroupSuccess: false,
    };
  },
  // DELETE VEHICLE GROUPS
  [types.FETCH_DELETE_USER_VEHICLE_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingDeleteVehicleGroup: true,
      fetchedDeleteUserVehicleGroupSuccess: false,
    };
  },
  [types.FETCH_DELETE_USER_VEHICLE_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingDeleteVehicleGroup: false,
      fetchedDeleteUserVehicleGroupSuccess: true,
    };
  },
  [types.FETCH_DELETE_USER_VEHICLE_GROUPS_FAILED]: (state) => {
    return {
      ...state,
      fetchingDeleteVehicleGroup: false,
      fetchedDeleteUserVehicleGroupSuccess: false,
    };
  },
  // DELETE USER GROUPS
  [types.FETCH_DELETE_USER_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingDeleteUserGroup: true,
      fetchedDeleteUserGroupSuccess: false,
    };
  },
  [types.FETCH_DELETE_USER_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingDeleteUserGroup: false,
      fetchedDeleteUserGroupSuccess: true,
    };
  },
  [types.FETCH_DELETE_USER_GROUPS_FAILED]: (state) => {
    return {
      ...state,
      fetchingDeleteUserGroup: false,
      fetchedDeleteUserGroupSuccess: false,
    };
  },
  // CREATE USER
  [types.FETCH_CREATE_USER_REQUEST]: (state) => {
    return {
      ...state,
      fetchedUserSuccess: false,
      fetchingUser: true,
    };
  },
  [types.FETCH_CREATE_USER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingUser: false,
      fetchedUserSuccess: true,
    };
  },
  [types.FETCH_CREATE_USER_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchedUserSuccess: false,
      fetchingUser: false,
      errors,
    };
  },
  // UPDATE USER
  [types.FETCH_UPDATE_USER_REQUEST]: (state) => {
    return {
      ...state,
      fetchedUserSuccess: false,
      fetchingUser: true,
    };
  },
  [types.FETCH_UPDATE_USER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      user: payload,
      fetchingUser: false,
      fetchedUserSuccess: true,
    };
  },
  [types.FETCH_UPDATE_USER_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchedUserSuccess: false,
      fetchingUser: false,
      errors,
    };
  },
  // DELETE USER
  [types.FETCH_DELETE_USER_REQUEST]: (state) => {
    return {
      ...state,
      message: null,
      fetchingDeleteUser: true,
      fetchedDeleteUserError: false,
      fetchedDeleteUserSuccess: false,
    };
  },
  [types.FETCH_DELETE_USER_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingdeleteUser: false,
      fetchedDeleteUserError: false,
      fetchedDeleteUserSuccess: true,
    };
  },
  [types.FETCH_DELETE_USER_FAILED]: (state, { payload }) => {
    return {
      ...state,
      fetchingDeleteUser: false,
      fetchedDeleteUserError: true,
      fetchedDeleteUserSuccess: false,
      message: payload?.message || null,
      showConfirmAction: payload?.showConfirm || false,
    };
  },
  // UPDATE USER
  [types.FETCH_UPDATE_USER_QUALIFICATIONS_REQUEST]: (state) => {
    return {
      ...state,
      fetchedUpdateUserSuccess: false,
      fetchingUpdateUser: true,
    };
  },
  [types.FETCH_UPDATE_USER_QUALIFICATIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      user: payload,
      fetchingUpdateUser: false,
      fetchedUpdateUserSuccess: true,
    };
  },
  [types.FETCH_UPDATE_USER_QUALIFICATIONS_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchingUpdateUser: false,
      fetchedUpdateUserSuccess: false,
    };
  },
  // GET USER PRIVILEGES
  [types.FETCH_USERS_PRIVILEGES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingPrivileges: true,
      userPrivileges: {},
    };
  },
  [types.FETCH_USERS_PRIVILEGES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      userPrivileges: payload?.privileges || {},
      fetchingPrivileges: false,
    };
  },
  [types.FETCH_USERS_PRIVILEGES_FAILURE]: (state, { errors }) => {
    return {
      ...state,
      fetchingPrivileges: false,
      userPrivileges: {},
      errors,
    };
  },
  // RESET UPDATE USER
  [types.RESET_UPDATE_USER_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedUserSuccess: false,
      fetchingUser: false,
      errors: {},
    };
  },
  // RESET DELETE USER
  [types.RESET_DELETE_USER_SUCCESS]: (state) => {
    return {
      ...state,
      errors: {},
      fetchingDeleteUser: false,
      showConfirmAction: false,
      fetchedDeleteUserSuccess: false,
    };
  },
  // RESET ASSIGN VEHICLE GROUPS
  [types.RESET_ADD_USER_VEHICLE_GROUPS_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedAddUserVehicleGroupSuccess: false,
    };
  },
  // ACCOUNT BROKERS
  [types.FETCH_ACCOUNT_BROKERS_REQUEST]: (state) => {
    return {
      ...state,
      fetchedAccountBrokers: false,
      fetchingAccountBrokers: true,
    };
  },
  [types.FETCH_ACCOUNT_BROKERS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedAccountBrokers: true,
      fetchingAccountBrokers: false,
      accountBrokers: payload,
    };
  },
  [types.FETCH_ACCOUNT_BROKERS_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchedAccountBrokers: false,
      fetchingAccountBrokers: false,
      errors,
    };
  },
  // DELETION USER
  [types.FETCH_DELETION_USER_REQUEST]: (state) => {
    return {
      ...state,
      message: null,
      fetchingDeletionUser: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_DELETION_USER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingDeletionUser: FETCH_STATE.DONE,
      user: payload,
    };
  },
  [types.FETCH_DELETION_USER_FAILED]: (state) => {
    return {
      ...state,
      fetchingDeletionUser: FETCH_STATE.ERROR,
    };
  },
  // RESET DELETION USER
  [types.RESET_DELETION_USER_SUCCESS]: (state) => {
    return {
      ...state,
      errors: {},
      showConfirmAction: false,
      fetchingDeletionUser: FETCH_STATE.UNSENT,
    };
  },
});

export default usersReducer;
